import { create } from 'zustand';

/**
 * Whether the canvas is read-only because the Tool tab is up: there a node can only be moved.
 * `AppBuilderStateProvider` feeds it from the deferred canvas flag, so the flip rides the pass that
 * already redraws the nodes for the Tool tab (WEA-6990), and it is off whenever the feature flag is.
 * A store rather than context, so a node re-renders only when this flips.
 */
export const toolTabReadOnlyStore = create<{ isReadOnly: boolean }>(() => ({ isReadOnly: false }));

export function useIsCanvasReadOnlyForToolTab(): boolean {
  return toolTabReadOnlyStore((state) => state.isReadOnly);
}

/** `useIsCanvasReadOnlyForToolTab` for code outside React. */
export function isCanvasReadOnlyForToolTab(): boolean {
  return toolTabReadOnlyStore.getState().isReadOnly;
}
